const getStoreFromLocalizer = () => {
  let localStore;

  if (typeof window !== 'undefined') {
    localStore = window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getLocalizedStore();
  }

  if (localStore === null || localStore === undefined) {
    return '';
  }
  return localStore;
};

export const getDeliveryZip = () => {
  let zipCode = '';
  try {
    if (typeof window !== 'undefined') {
      const zipDetails = window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getDeliveryZipcodeDetails();
      zipCode = zipDetails?.zipcode;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return zipCode;
};

export const getThdStore = () => {
  const store = getStoreFromLocalizer();
  if (store) {
    return {
      ...store,
      storeNumber: store.storeId,
      storeName: store.name,
    };
  }
  return {
    storeNumber: 121,
    storeFullName: 'Cumberland - Atlanta, GA',
    storeName: 'Cumberland',
  };
};
